import React from 'react';
import { SocialIcon } from 'react-social-icons';
import './AwesomeFooter.css';

const AwesomeFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="awesome-footer">
      <div className="awesome-footer-container">
        <div className="awesome-footer-main">
          {/* Logo & Description */}
          <div className="awesome-footer-brand">
            <img
              src="/logo_sigma/SVG/white.svg"
              alt="Sigma Study"
              className="awesome-footer-logo"
            />
            <p className="awesome-footer-description">
              Profesjonalne korepetycje z matematyki online.
              Pomagamy uczniom osiagac sukces na egzaminach.
            </p>
            <div className="awesome-footer-social">
              <SocialIcon
                url="https://www.facebook.com/people/Sigma-Study/61576967721817/"
                style={{ height: 36, width: 36 }}
                bgColor="transparent"
                fgColor="#ffffff"
              />
              <SocialIcon
                url="https://www.instagram.com/sigma_study_/"
                style={{ height: 36, width: 36 }}
                bgColor="transparent"
                fgColor="#ffffff"
              />
            </div>
          </div>

          {/* Courses */}
          <div className="awesome-footer-column">
            <h4 className="awesome-footer-title">Kursy</h4>
            <ul className="awesome-footer-links">
              <li><a href="#courses">Matura Podstawowa</a></li>
              <li><a href="#courses">Matura Rozszerzona</a></li>
              <li><a href="#courses">Egzamin Osmoklasisty</a></li>
              <li><a href="#courses">Konkursy i Olimpiady</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="awesome-footer-column">
            <h4 className="awesome-footer-title">Firma</h4>
            <ul className="awesome-footer-links">
              <li><a href="#teachers">O nas</a></li>
              <li><a href="#testimonials">Opinie</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#pricing">Cennik</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="awesome-footer-column">
            <h4 className="awesome-footer-title">Kontakt</h4>
            <ul className="awesome-footer-contact">
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
                <a href="tel:+48532533220">+48 532 533 220</a>
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                <a href="mailto:info@sigma-study.net">info@sigma-study.net</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="awesome-footer-bottom">
          <p className="awesome-footer-copyright">
            {currentYear} Sigma Study. Wszystkie prawa zastrzezone.
          </p>
          <div className="awesome-footer-legal">
            <a href="/polityka-prywatnosci">Polityka prywatnosci</a>
            <a href="/regulamin">Regulamin</a>
            <a href="/cookies">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AwesomeFooter;
